module.exports = __webpack_public_path__ + "img/princial-aboutUs.f53085b0.jpg";